import { createSlice } from '@reduxjs/toolkit';
import { createAppAsyncThunk } from '../../createAppAsyncThunk';
import { API_POST } from '../../../services';
import { KeyOperationalRolling2Model } from '../../../models/KeyOperationalRolling2Model';
import type { RootState } from '../../store';
import { env } from '../../../env';
import { ENDPOINTS } from '../../../constants/endPoints';
import { RADRequest } from '../../../models/common/RADRequest';

interface KeyOperationalMetricsState {
  data: KeyOperationalRolling2Model | null;
  isLoading: boolean;
}

const initialState: KeyOperationalMetricsState = {
  data: null,
  isLoading: false,
};

// Async thunk to fetch Key Operational Metrics data
export const fetchKeyOperationalMetrics = createAppAsyncThunk(
  'ecommerce/fetchKeyOperationalMetrics',
  async (payload: RADRequest) => {
    const requestBody = {
      StoreNumber: payload.storeNumber,
      IsMultiStoreMode: payload.isMultiStoreMode,
    };

    const response = await API_POST(
      `${env.RAD_APP_API_URL}${ENDPOINTS.GET_KOM_ROLLING}`,
      requestBody,
    );
    return response as KeyOperationalRolling2Model;
  },
);

// Key Operational Metrics slice
const keyOperationalMetricsSlice = createSlice({
  name: 'keyOperationalMetrics',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchKeyOperationalMetrics.pending, state => {
        state.isLoading = true;
        state.data = null;
      })
      .addCase(fetchKeyOperationalMetrics.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchKeyOperationalMetrics.rejected, state => {
        state.data = null;
        state.isLoading = false;
      });
  },
});

// Selectors
export const selectKeyOperationalMetrics = (state: RootState) => state.keyOperationalMetrics.data;
export const selectKeyOperationalMetricsLoading = (state: RootState) =>
  state.keyOperationalMetrics.isLoading;
export const selectKeyOperationalMetricsIsNull = (state: RootState) =>
  state.keyOperationalMetrics.data === null;

export default keyOperationalMetricsSlice.reducer;
